/* eslint-disable no-shadow */
import * as types from './action-types';
import * as registerFormApi from '../api/register-form-api';
import * as apiResponseMessages from './api-response-messages';
import * as dataFormatHelper from './helpers/data-format-helper';
import { beginApiCall, apiCallError } from './api-status-actions';

export function loadSSORegisterFormDataSuccess(registerFormData) {
    return { type: types.LOAD_REGISTER_FORM_DATA_SUCCESS, registerFormData };
}

export function loadSSORegisterFormDataError() {
    return { type: types.LOAD_REGISTER_FORM_DATA_ERROR };
}

export function registerUserSuccess(userName, userRegistrationMessages) {
    return { type: types.REGISTER_USER_SUCCESS, userName, userRegistrationMessages };
}

export function registerUserError(userRegistrationMessages) {
    return { type: types.REGISTER_USER_ERROR, userRegistrationMessages };
}

export function resendEmailVerificationSuccess(resendEmailVerificationMessages) {
    return { type: types.RESEND_EMAIL_VERIFICATION_SUCCESS, resendEmailVerificationMessages };
}

export function resendEmailVerificationError(resendEmailVerificationMessages) {
    return { type: types.RESEND_EMAIL_VERIFICATION_ERROR, resendEmailVerificationMessages };
}

export function resetRegisterFormState() {
    return { type: types.RESET_REGISTER_FORM_STATE };
}

export function verifyIfUserEmailExistsError(verifyIfUserEmailExistsErrorMessages) {
    return { type: types.VERIFY_IF_USER_EMAIL_EXISTS_ERROR, verifyIfUserEmailExistsErrorMessages };
}

export function verifyIfUserEmailExistsSuccess(verifyIfUserEmailExistsSuccess) {
    return { type: types.VERIFY_IF_USER_EMAIL_EXISTS_SUCCESS, verifyIfUserEmailExistsSuccess };
}

export function loadSSODefaultRegisterFormData() {
    return function (dispatch) {
        dispatch(beginApiCall());
        return registerFormApi.getSSODefaultRegisterFormData()
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(loadSSORegisterFormDataError());
                    return;
                }
                dispatch(loadSSORegisterFormDataSuccess(response.data));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(loadSSORegisterFormDataError());
                throw error;
            });
    };
}

export function loadSSOOneClubRegisterFormData(formDataUrl) {
    return function (dispatch) {
        dispatch(beginApiCall());
        return registerFormApi.getSSOOneClubRegisterFormData(formDataUrl)
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(loadSSORegisterFormDataError());
                    return;
                }
                dispatch(loadSSORegisterFormDataSuccess(response.data));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(loadSSORegisterFormDataError());
                throw error;
            });
    };
}

export function loadSSOTicketingRegisterFormData() {
    return function (dispatch) {
        dispatch(beginApiCall());
        return registerFormApi.getSSOTicketingRegisterFormData()
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(loadSSORegisterFormDataError());
                    return;
                }
                dispatch(loadSSORegisterFormDataSuccess(response.data));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(loadSSORegisterFormDataError());
                throw error;
            });
    };
}

export function loadSSORaMembersRegisterFormData() {
    return function (dispatch) {
        dispatch(beginApiCall());
        return registerFormApi.getSSORaMembersRegisterFormData()
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(loadSSORegisterFormDataError());
                    return;
                }
                dispatch(loadSSORegisterFormDataSuccess(response.data));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(loadSSORegisterFormDataError());
                throw error;
            });
    };
}

export function resendEmailVerification({
    emailAddress,
    ssoDomain,
    callBackUrl,
    actionSuccessText
}) {
    return function (dispatch) {
        dispatch(beginApiCall());
        return registerFormApi.resendEmailVerification(dataFormatHelper.getFormattedUserEmailData(emailAddress, ssoDomain), callBackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(resendEmailVerificationError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                    return;
                }
                dispatch(resendEmailVerificationSuccess([actionSuccessText]));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(resendEmailVerificationError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function registerNewUser(userRegistrationData, actionSuccessText, callBackUrl) {
    return function (dispatch) {
        dispatch(beginApiCall());
        return registerFormApi.registerNewUser(dataFormatHelper.getFormattedUserRegistrationData(userRegistrationData), callBackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(registerUserError([response.errorMessage]));
                    return;
                }

                const { userName } = response;
                dispatch(registerUserSuccess(userName, [actionSuccessText]));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(registerUserError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function verifyIfEmailAddressExists(emailAddress, callBackUrl) {
    return function (dispatch) {
        dispatch(beginApiCall());
        return registerFormApi.verifyIfEmailAddressExists(emailAddress, callBackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(verifyIfUserEmailExistsError([response.errorMessage]));
                    return;
                }

                dispatch(verifyIfUserEmailExistsSuccess(true));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(verifyIfUserEmailExistsError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}
